import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../api/store';
import { hideToast, Toast } from '../../../store/toastSlice';
import { ToastItem } from './Toast';

interface ToastContainerProps {
  autoHideDuration?: number;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  maxToasts?: number;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({
  autoHideDuration = 5000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
  maxToasts = 3,
}) => {
  const dispatch = useDispatch();
  const toasts = useSelector((state: RootState) => state.toast.toasts);

  const handleClose = (id: string) => {
    dispatch(hideToast(id));
  };

  // Show only the most recent toasts up to maxToasts
  const visibleToasts = toasts.slice(-maxToasts);

  return (
    <>
      {visibleToasts.map((toast: Toast) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          onClose={handleClose}
          autoHideDuration={autoHideDuration}
          anchorOrigin={anchorOrigin}
        />
      ))}
    </>
  );
};

